import { render, staticRenderFns } from "./offerDetailPopup.vue?vue&type=template&id=078a4858&scoped=true"
import script from "./offerDetailPopup.vue?vue&type=script&lang=js"
export * from "./offerDetailPopup.vue?vue&type=script&lang=js"
import style0 from "./offerDetailPopup.vue?vue&type=style&index=0&id=078a4858&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "078a4858",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/prod-www.dijie360.com-nginx/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('078a4858')) {
      api.createRecord('078a4858', component.options)
    } else {
      api.reload('078a4858', component.options)
    }
    module.hot.accept("./offerDetailPopup.vue?vue&type=template&id=078a4858&scoped=true", function () {
      api.rerender('078a4858', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/mechanism/components/offerDetailPopup.vue"
export default component.exports